var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#FDEDEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 55.977L46.0156 72L80 38",
    stroke: "#EC4C41",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e9cf8e5cc2dccdb5b86c9cc02cad8b5f.svg";
export { ForwardRef as ReactComponent };